import GenericDB from './generic-db';

export default class TableViewsDB extends GenericDB {
  constructor() {
    super('tableViews');
  }
}
